module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/minus-71cf4b13e2ce57b3daee914788073386.svg";